export const dashboardSprings = {
  primary: {
    type: 'spring',
    stiffness: 320,
    damping: 34,
    mass: 0.95,
  },
  secondary: {
    type: 'spring',
    stiffness: 260,
    damping: 30,
    mass: 0.95,
  },
  micro: {
    type: 'spring',
    stiffness: 420,
    damping: 38,
    mass: 0.8,
  },
} as const;

export const dashboardTransitions = {
  layoutStrong: {
    layout: dashboardSprings.primary,
  },
  layoutSoft: {
    layout: dashboardSprings.secondary,
  },
  interaction: dashboardSprings.micro,
  dropdownOpen: {
    type: 'spring',
    duration: 0.45,
    bounce: 0.2,
  },
  dropdownItem: {
    duration: 0.16,
  },
  themeCoverflow: {
    type: 'spring',
    duration: 0.65,
    bounce: 0.3,
  },
  themeCarousel: {
    type: 'spring',
    duration: 0.35,
    bounce: 0.15,
  },
  fadeFast: {
    duration: 0.18,
  },
} as const;
